const generateIptvStats = data => [
  {
    title: 'Monitored IPTV',
    subtitle: 'Applications',
    total: data?.monitoring ?? 0,
    chartData: [
      {
        name: 'Visitors',
        data: [69, 34, 70, 73, 41, 32, 73, 72, 89, 57, 42, 86, 78],
      },
    ],
    chartType: 'bar',
    chartHeight: 30,
  },
  {
    title: 'Detected',
    subtitle: 'Domains/IPs',
    total: data?.detected ?? 0,
    chartData: [
      {
        name: 'Sales',
        data: [81, 89, 71, 75, 53, 47, 78, 33, 71, 81, 45, 43, 68],
      },
    ],
    chartType: 'line',
    chartHeight: 30,
  },
  {
    title: 'Reported',
    subtitle: 'Streams',
    total: data?.reported ?? 0,
    chartData: [
      {
        name: 'Sales',
        data: [81, 89, 71, 75, 53, 47, 78, 33, 71, 81, 45, 43, 68],
      },
    ],
    chartType: 'line',
    chartHeight: 30,
  },
  {
    title: 'Disconnected / Content Removed',
    subtitle: 'Streams',
    total: data?.disconnected_or_content_removed ?? 0,
    chartData: [77, 80, 70],
    chartType: 'pie',
    chartHeight: 30,
  },
];

export default generateIptvStats;
